var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"context-viewer"},[_c('pre',{staticClass:"json-content"},[_vm._v(_vm._s(_vm.prettyJson))])])
}
var staticRenderFns = []

export { render, staticRenderFns }